import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  BatchHistoryQuery,
  BatchHistoryQueryVariables
} from "./types/BatchHistoryQuery";

export const BatchHistoryList = gql`
  ${pageInfoFragment}
  query BatchHistoryQuery(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: BatchHistoryFilterInput!
  ) {
    batchHistory(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        node {
          id
          credit_date
          coverage_start_date
          coverage_end_date
          batch_status
          mall_name
          mall_code
          cancelled_by
          generated_at
        }
      }
    }
  }
`;

export const useBatchListHistoryQuery = makeBossQuery<
  BatchHistoryQuery,
  BatchHistoryQueryVariables
>(BatchHistoryList);
